import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'

const ClearFilter = styled.div`
    position: absolute;
    bottom: 1px;
    right: 0px;
    height: calc(1.5em + 0.75rem + 2px);
    width: calc(1.5em + 0.75rem + 2px);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

const FilterInput = styled.div`
    width: 100%;

    ${breakpoint('laptop')`
        width: auto;
    `};
`

const NoSpinnerInput = styled.input`
    -webkit-appearance: none;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`

const TextFilter = ({
    label,
    placeholder,
    column,
    onApplyFilters,
    setAllFilters,
    gotoPage,
    state,
    step,
    type = 'text',
    selectedFilters = [],
}) => {
    const path = window.location.pathname
    const claims = window.localStorage.getItem('claims')
    const user = claims ? JSON.parse(claims)['id'] : ''

    useEffect(() => {
        let storedFilters = JSON.parse(window.localStorage.getItem(`${user}_filterValues${path}`))

        if (storedFilters && storedFilters[column.id]) {
            column.setFilter(storedFilters[column.id])
        }
    }, [])

    return (
        <>
            {selectedFilters[column.id] && (
                <FilterInput className="!mb-2 form-group lg:!mb-0 lg:!mr-2 !relative">
                    <label>{label}</label>
                    <NoSpinnerInput
                        className="form-control"
                        type={type}
                        placeholder={placeholder ? placeholder : label}
                        value={column.filterValue || ''}
                        data-testid={`text-filter-${label.toLowerCase().replaceAll(' ', '-')}`}
                        onChange={e => {
                            column.setFilter(e.target.value)
                        }}
                        onKeyDown={e => {
                            if (e.keyCode == 13 || e.which == 13) {
                                onApplyFilters()
                                gotoPage(0)
                            }
                        }}
                        step={step}
                    />
                    {column.filterValue && column.filterValue.length > 0 && (
                        <ClearFilter
                            role="button"
                            onClick={() => {
                                setAllFilters({
                                    ...state[0].filters,
                                    [column.id]: '',
                                })
                                onApplyFilters()
                                gotoPage(0)
                            }}
                        >
                            <FontAwesomeIcon icon={faTimes} size="lg" />
                        </ClearFilter>
                    )}
                </FilterInput>
            )}
        </>
    )
}

TextFilter.propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    column: PropTypes.shape({
        filterValue: PropTypes.string,
        setFilter: PropTypes.func.isRequired,
    }),
    onApplyFilters: PropTypes.func.isRequired,
}

export default TextFilter
